import $ from 'jquery';
import Swal from 'sweetalert2';

let districts = [];

export default function() {
  addAddress();
  updateAddressModal();
  updateAddress();
  deleteAddress();
  setPrimaryAddress();

  $(document).on('change', '.js-select-city', function(e){
    e.preventDefault();
    const cityid = $(this).val();

    if(cityid) 
    {
      $('.js-select-district option:not(:first)').remove();
      getDistrictByCity(cityid);
    }
  });
}

function addAddress()
{
  $('.js-address-add-form').on('submit', function(e) {
    e.preventDefault();

    if(!$(this).valid())
      return;

    if($(this).find('select[name=CityID]').val() == '-1' || $(this).find('select[name=DistrictID]').val() == '-1')
    {
      Swal.fire(window.LANG.default.LABEL_WARNING, window.LANG.default.FORM_REQUIRED, 'warning');
      return;
    }

    const formData = new FormData($(this)[0]);
    const $that = $(this);

    window.waitMe($(this), $(this).data('loading-text'));

    $.ajax({
      url: window.GLOBALS.baseLink + 'panel/adreslerim/ekle',
      type: 'POST',
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      success: function(response) {
        if (response) {
          if (response.IsSuccess) {
            Swal.fire(response.Title, response.Message, response.Class,
            );
            if (response.Redirect) {
              setTimeout(function () {
                window.location.href = response.Redirect;
              }, 1000)
            }
            window.closeWaitMe($that);
          } else {
            Swal.fire(response.Title, response.Message, {
              icon: response.Class,
              buttons: false
            });
            window.closeWaitMe($that);
          }
        }
      }
    })

  })
}

function updateAddressModal()
{
  $(document).on('click', '.js-update-address', function(e){
    e.preventDefault();

    const addressid = $(this).data('address-id');

    if(addressid)
    {
      $('#addressModal').modal('show');
      window.waitMe($('#addressModal'), $('.js-address-update-form').data('loading-text'));

      $.ajax({
        url: window.GLOBALS.baseLink + 'panel/adreslerim/detay',
        type: 'POST',
        data: { AddressID: addressid},
        dataType: 'json',
        success: function(response) {
          if (response) {
            if (response.IsSuccess) {
              
              if(response.Address)
              {
                getDistrictByCity(response.Address.CityID);
                setTimeout(() => {
                  $.each(response.Address, function(i,e) {
                    $(`.js-address-update-form`).find(`[name=${i}]`).val(e)
                  });
                  window.closeWaitMe($('#addressModal'));
                }, 1000);
              }
            } else {
              window.closeWaitMe($('#addressModal'));
            }
          }
        }
      })
    }
  })
}

function updateAddress()
{
  $('.js-address-update-form').on('submit', function(e) {
    e.preventDefault();

    if(!$(this).valid())
      return;

    if($(this).find('select[name=CityID]').val() == '-1' || $(this).find('select[name=DistrictID]').val() == '-1')
    {
      Swal.fire(window.LANG.default.LABEL_WARNING, window.LANG.default.FORM_REQUIRED, 'warning');
      return;
    }

    const formData = new FormData($(this)[0]);
    const $that = $(this);

    window.waitMe($(this), $(this).data('loading-text'));


    $.ajax({
      url: window.GLOBALS.baseLink + 'panel/adreslerim/guncelle',
      type: 'POST',
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      beforeSend: function(xhr) {
        xhr.setRequestHeader('_token', $(this).find('[name=_token]').val());
      },
      success: function(response) {
        if (response) {
          if (response.IsSuccess) {
            Swal.fire(response.Title, response.Message, response.Class,
            );
            if (response.Redirect) {
              setTimeout(function () {
                window.location.href = response.Redirect;
              }, 1000)
            }
            window.closeWaitMe($that);
          } else {
            Swal.fire(response.Title, response.Message, {
              icon: response.Class,
              buttons: false
            });
            window.closeWaitMe($that);
          }
        }
      }
    })

  })
}

function deleteAddress()
{
 $('.js-delete-address').on('click', function(e){
  e.preventDefault();

  const addressid = $(this).data('address-id');

  if(addressid)
  {
    window.waitMe($(this).closest('.js-address-item'));

    Swal.fire({
      title: window.LANG.default.LABEL_WARNING,
      text: window.LANG.default.CONFIRM_ADDRESS_DELETED,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: window.LANG.default.LABEL_CANCEL,
      confirmButtonText: window.LANG.default.LABEL_DELETE
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          url: window.GLOBALS.baseLink + 'panel/adreslerim/sil',
          type: 'POST',
          data: {AddressID: addressid},
          dataType: 'json',
          success: function(response) {
            if (response) {
              if (response.IsSuccess) {
                Swal.fire(response.Title, response.Message, response.Class,
                );
                if (response.Redirect) {
                  setTimeout(function () {
                    window.location.href = response.Redirect;
                  }, 1000)
                }
                window.closeWaitMe($(this).closest('.js-address-item'));
              } else {
                Swal.fire(response.Title, response.Message, {
                  icon: response.Class,
                  buttons: false
                });
                window.closeWaitMe($(this).closest('.js-address-item'));
              }
            }
          }
        })
      }
    })


    

  }
 }) 
}

function setPrimaryAddress()
{
  $('.js-primary-address').on('click', function(e){
    e.preventDefault();

    const addressid = $(this).data('address-id');

    if(addressid)
    {
      window.waitMe($(this).closest('.js-address-item'));

      $.ajax({
        url: window.GLOBALS.baseLink + 'panel/adreslerim/varsayilan',
        type: 'POST',
        data: {AddressID: addressid},
        dataType: 'json',
        success: function(response) {
          if (response) {
            if (response.IsSuccess) {
              Swal.fire(response.Title, response.Message, response.Class,
              );
              if (response.Redirect) {
                setTimeout(function () {
                  window.location.href = response.Redirect;
                }, 1000)
              }
              window.closeWaitMe($(this).closest('.js-address-item'));
            } else {
              Swal.fire(response.Title, response.Message, {
                icon: response.Class,
                buttons: false
              });
              window.closeWaitMe($(this).closest('.js-address-item'));
            }
          }
        }
      })
    }
    
  })
}

function getDistrictByCity(cityid) 
{
  if(cityid)
  {
    $.ajax({
      url: window.GLOBALS.baseLink + 'get-district-by-city',
      type: 'GET',
      data: { CityID: cityid},
      dataType: 'json',
      success: function(response) {
        if (response) {
          if (response.IsSuccess) {
            
            if(response.Districts)
            {
              $.each(response.Districts, function(i, item){
                $('.js-select-district').append($('<option>', {
                  value: item.DistrictID,
                  text: item.DistrictName
                }));
              })
            }
          }
        }
      }
    })
  }
}